import { render, staticRenderFns } from "./ScreenExameDopplerDasArteriasOftalmicas.vue?vue&type=template&id=14a72640&scoped=true&"
import script from "./ScreenExameDopplerDasArteriasOftalmicas.vue?vue&type=script&lang=js&"
export * from "./ScreenExameDopplerDasArteriasOftalmicas.vue?vue&type=script&lang=js&"
import style0 from "./ScreenExameDopplerDasArteriasOftalmicas.vue?vue&type=style&index=0&id=14a72640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a72640",
  null
  
)

export default component.exports